import { Component, AfterViewInit, Injector } from "@angular/core";
import { DiagnosedItem } from "../../../dataModels/diagnosed-item";
import { MapService } from "../../../services/maps/map.service";

@Component({

    moduleId: module.id,
    selector: 'map-toc',
    templateUrl: 'map-toc.component.html',

})
export class MapTocComponent extends DiagnosedItem implements AfterViewInit {
    public toggleActive: boolean = false;
    public layers: any[] = [];

    constructor(protected injector: Injector, private mapService: MapService) {
        super(injector);
    }

    ngAfterViewInit() {
        // this.mapService.MapLoaded.subscribe(() => {
        //     var mapLayers: any = this.mapService.getMapLayers();
        //     for (let layer of mapLayers.a) {
        //         let xlayer: any = new Object();
        //         xlayer.DisplayName = layer.DisplayName;
        //         xlayer.checked = layer.getVisible();
        //         xlayer.layer= layer;
        //         this.layers.push(xlayer);
        //     }
        // });
        let baselayer: any = new Object();
        baselayer.DisplayName = "XY Label";
        baselayer.checked = true;
        this.layers.push(baselayer);
        let trafficlayer: any = new Object();
        trafficlayer.DisplayName = "Traffic";
        trafficlayer.checked = true;
        this.layers.push(trafficlayer);

    }

    public onToggle(layer) {
        // layer.checked= !layer.layer.getVisible();
        // this.mapService.changeLayerVisible(layer.DisplayName);
        if (layer.DisplayName == "XY Label")
            {
                 var d= document.getElementById("mouse-position").style.visibility;
                 if(d=="" || d=="visible")
                document.getElementById("mouse-position").style.visibility = "hidden";
                else
                document.getElementById("mouse-position").style.visibility = "visible";
                //this.mapService.changeBaseLayerVisible();
            }
        else
            this.mapService.changeTrafficLayerVisible(layer.checked);

    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/mapTools/mapToc/map-toc.component.ts